import { useState, useEffect } from "react";
import AuthForm from "../../common/authForm/AuthForm";
import validateFields from "../../ValidationChecker";
import MembersList from "./MembersList";
import { Button } from "react-bootstrap";
import ReactNotifications, { showApiErrors } from "../../common/reactNotifications/ReactNotifications";
import { memberEmailVerification } from "../../../api/authApi";
import * as utilConstants from "../../../utils/constants/utilsConstants";

const InviteMembers = ({ step, setStep, members, setMembers, formValues }) => {
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const customFields = [
        {
            name: "first_name",
            type: "text",
            placeholder: "First Name",
            label: "First Name",
            required: true,
        },
        {
            name: "last_name",
            type: "text",
            placeholder: "Last Name",
            label: "Last Name",
            required: true,
        },
        {
            name: "email",
            type: "email",
            placeholder: "E-Mail",
            label: "Email",
            required: true,
        },
    ];

    useEffect(() => {
        if (formValues?.first_name && formValues?.last_name && formValues?.email) {
            const owner = {
                first_name: formValues.first_name,
                last_name: formValues.last_name,
                email: formValues.email,
                role: "Company Head",
            };

            setMembers((prev) => {
                const filtered = prev.filter(
                    (m) => m.role !== "Company Head" && m.email !== owner.email
                );
                return [owner, ...filtered];
            });
        }
    }, [formValues, setMembers]);


    const handleSubmit = (event, values) => {
        event.preventDefault();
        const allTouched = customFields.reduce((acc, field) => {
            acc[field.name] = true;
            return acc;
        }, {});
        setTouched(allTouched);

        const { isValid, errors } = validateFields(values, customFields);

        if (isValid) {
            setErrors({});
            const newMember = {
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                role: "Awaiting",
            };

            memberEmailVerification({ email: values?.email }, (res) => {
                if (res?.data?.status === true) {
                    setMembers((prev) => {
                        const filtered = prev.filter((m) => m.email !== newMember.email);
                        return [...filtered, newMember];
                    });
                } else {
                    showApiErrors(res);
                }
            })

        } else {
            setErrors(errors);
        }

    };


    return (
        <>
            <AuthForm
                formType="New User Profile"
                initialValues={{
                    first_name: "",
                    last_name: "",
                    email: "",
                }}
                onSubmit={handleSubmit}
                successRedirectPath="/login"
                buttonLabel="Send Invitation"
                loadingLabel="Sending..."
                customFields={customFields}
                isCustomSubmitFunction={true}
                customFunctionErrors={errors}
                stepper={true}
                step={step}
                title="Add members to your team"
                subTitle="Add members in your workspace"
                mdSize={6}
                touched={touched}
                setTouched={setTouched}
            >
                <MembersList members={members} setMembers={setMembers} />

                <div className="float-end mt-3 d-flex justify-content-end gap-2">
                    <Button onClick={() => setStep(1)} variant='outline-light'
                        className="!text-[#000] border border-2 px-4 !font-medium">
                        Back
                    </Button>
                    <Button
                        className="!bg-[#AEF468] !border-none !text-black !font-medium"
                        disabled={members?.length < 2}
                        onClick={() => setStep(3)}
                    >
                        Continue
                    </Button>
                </div>
            </AuthForm>
        </>
    );
};

export default InviteMembers;
